import { plainToClass } from 'class-transformer';
import { inject } from '@/inversify.inject';
import { injectable } from '@/inversify.injectable';
import { KEY } from '@/inversify.keys';
import { TriggerScheduleModel } from './models/trigger-schedule.model';
import ApiService from '../common/services/api.service';

@injectable()
export default class RMSApiService {
    @inject(KEY.ApiService)
    private apiService!: ApiService;

    async getTriggerSchedules(compsetId: string): Promise<TriggerScheduleModel[]> {
        const response = await this.apiService.get(`compsets/rms-trigger-schedules/${compsetId}`);

        return plainToClass(
            TriggerScheduleModel,
            response.data.rms_trigger_schedules as any[],
            { excludeExtraneousValues: true },
        );
    }
}
